import gql from "graphql-tag";
import type { AssetFragment } from "./asset-fragment";
import type { LinkFragment } from "./link-fragment";

/** Card fields for the Rückblick overview list. */
export const festivalCardFragment = gql`
  fragment festivalCardFragment on festival_Entry {
    id
    title
    slug
    uri
    edition
    startDate
    endDate
    statement {
      html
    }
    poster {
      ...assetFragment
    }
    programPdf {
      url
      filename
    }
  }
`;

export type FestivalCardFragment = {
  id: string;
  title: string | null;
  slug: string | null;
  uri: string | null;
  edition: string | null;
  startDate: string | null;
  endDate: string | null;
  statement: { html: string | null } | null;
  poster: AssetFragment[];
  programPdf: { url: string; filename: string }[];
};

/** Full festival fields (Rückblick detail / active festival). */
export const festivalFragment = gql`
  fragment festivalFragment on festival_Entry {
    id
    title
    slug
    uri
    edition
    startDate
    endDate
    sujet {
      ...assetFragment
    }
    sujetPosition
    colorPrimary
    colorSecondary
    poster {
      ...assetFragment
    }
    statement {
      html
    }
    ticketLink {
      type
      url
      label
      target
    }
    eindruecke {
      ...assetFragment
    }
    videoFile {
      ...assetFragment
    }
    programPdf {
      url
      filename
    }
    programmCover {
      ...assetFragment
    }
    metaTitle
    metaDescription
    ogImage {
      ...assetFragment
      ogImageUrl: url @transform(handle: "opengraph")
    }
    metaTags
  }
`;

/** Vertical anchoring of the hero sujet, set per festival in the CMS. */
export type SujetPosition = "top" | "center" | "bottom";

export type FestivalFragment = FestivalCardFragment & {
  sujet: AssetFragment[];
  /** Null until an editor picks one — treat as "center". */
  sujetPosition: SujetPosition | null;
  /** Seasonal hero colours (hex); null falls back to the theme defaults. */
  colorPrimary: string | null;
  colorSecondary: string | null;
  statement: { html: string | null } | null;
  ticketLink: LinkFragment | null;
  eindruecke: AssetFragment[];
  videoFile: AssetFragment[];
  programmCover: AssetFragment[];
  metaTitle: string | null;
  metaDescription: string | null;
  ogImage: (AssetFragment & { ogImageUrl: string | null })[];
  metaTags: string | null;
};
